import clsx from 'clsx'
import React, {forwardRef} from 'react'
import defaultUserAvatar from '../../styles/theme/images/avatar-user.svg'
import {Avatar as AvatarRoot} from '../../ui/Avatar/Avatar'
import {AvatarFallback} from '../../ui/Avatar/AvatarFallback'
import {AvatarImage} from '../../ui/Avatar/AvatarImage'










const Avatar = forwardRef((props, ref) => {
  const {alt, className, onClick, onTransitionEnd, onMouseEnter, picture} = props
  return (
    React.createElement(AvatarRoot, {
      onClick: onClick,
      onTransitionEnd: onTransitionEnd,
      onMouseEnter: onMouseEnter,
      ref: ref,
      className: clsx(`${onClick && 'cursor-pointer'}`, className),}

      , React.createElement(AvatarImage, { src: picture || defaultUserAvatar, alt: alt || 'Avatar',} )
      , React.createElement(AvatarFallback, null
        , React.createElement('img', { src: defaultUserAvatar, alt: alt || 'Avatar not found',} )
      )
    )
  )
})

export default Avatar
